__turbopack_context__.v({
  "disabled": "SwitchButton-module__YA0MwW__disabled",
  "icon": "SwitchButton-module__YA0MwW__icon",
  "main": "SwitchButton-module__YA0MwW__main",
  "option": "SwitchButton-module__YA0MwW__option",
  "selected": "SwitchButton-module__YA0MwW__selected",
});
